<agr-form-dialog
  [formGroup]="formGroup"
  [data]="data"
  [hideActionButtons]="true"
  class="fertilization-balance-dialog"
  data-test="edit-fertilization-balance-settings"
  (cancel)="cancel()"
  (confirm)="confirm($event)"
>
  <div class="fertilization-balance-content">
    @for (warning of headerWarningTranslationCodes; track warning) {
      <div class="background-color--alert-50 warning-label text-color--alert-500">
        {{ warning | translate }}
      </div>
    }

    <agr-notification-empty
      [isEmpty]="data.fertilizationBalanceSettings.length === 0"
      [emptyTitle]="'noCropFieldsTitle' | translate"
      [emptyDescription]="'fertilizationBalance.noCropFieldsDescription' | translate"
      [emptyImage]="false"
      class="fertilization-wrapper"
    >
      <app-fertilization-balance-setting-detail
        [dataSource]="sortedSettings()"
        [formGroupByAdviceId]="formGroupByAdviceId"
        (editSpecificReferenceBlock)="openEditSpecificReferenceBlockDialog($event)"
      ></app-fertilization-balance-setting-detail>
    </agr-notification-empty>
  </div>
</agr-form-dialog>

<div mat-dialog-actions data-test="dialogButtons" class="fertilization-balance-footer">
  <div class="fertilization-balance-footer-layout">
    <div>
      <button
        type="button"
        data-test="form-dialog-cancel"
        mat-button
        [color]="data.cancelButtonColor"
        (click)="cancel()"
      >
        {{ data.cancelButtonText }}
      </button>
    </div>
    <div class="fertilization-balance-footer-actions">
      <button
        type="button"
        data-test="send-participation-mail"
        mat-flat-button
        color="primary"
        (click)="sendParticipationMail()"
        [disabled]="sendParticipationMailDisabled()"
      >
        {{
          'fertilizationBalance.sendParticipationMail'
            | translate: { cropYear: cropYear().toString() }
        }}
      </button>
      <button
        type="button"
        data-test="send-cancellation-mail"
        mat-flat-button
        color="primary"
        (click)="sendCancellationMail()"
        [disabled]="sendCancellationMailDisabled()"
      >
        {{
          'fertilizationBalance.sendCancellationMail'
            | translate: { cropYear: cropYear().toString() }
        }}
      </button>
      @if (data.altButton) {
        <button
          type="button"
          data-test="form-dialog-alt"
          mat-button
          [color]="data.altButtonColor"
          (click)="alt()"
        >
          @if (data.altButtonIcon) {
            <mat-icon>{{ data.altButtonIcon }}</mat-icon>
          }
          {{ data.altButtonText }}
        </button>
      }
      @if (data.confirmButton) {
        <button
          type="button"
          data-test="form-dialog-submit"
          mat-flat-button
          [color]="data.confirmButtonColor"
          [disabled]="formGroup.invalid"
          (click)="confirm()"
          cdkFocusInitial
        >
          {{ data.confirmButtonText }}
        </button>
      }
    </div>
  </div>
</div>
